// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { IObjectEntity } from 'types/graphql'

export interface ObjectEntitiesState {
  data: IObjectEntity[]
}

const initialState: ObjectEntitiesState = {
  data: []
}

export const objectEntitiesSlice = createSlice({
  name: Reducers.OBJECT_ENTITIES,
  initialState,
  reducers: (create) => ({
    setObjectEntities: create.reducer((state, action: PayloadAction<IObjectEntity[]>) => {
      state.data = action.payload
    }),
    updateObjectEntities: create.reducer(
      (state, action: PayloadAction<{ id: string, data: IObjectEntity }>) => {
        state.data = state.data.map(item => {
          if (item.id === action.payload.id) {
            return { ...item, ...action.payload.data }
          }
          return item
        })
      }
    )
  }),
  selectors: {
    objectEntitiesSelector: (state) => state.data
  }
})

export const {
  setObjectEntities,
  updateObjectEntities
} =
  objectEntitiesSlice.actions

export const { objectEntitiesSelector } = objectEntitiesSlice.selectors
